import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/Projects/ProjectsApi";
import { useAddTaskMutation } from "../../features/Task/TaskApi";
import { useGetTeamQuery } from "../../features/TeamMembers/TeamMembersApi";

const AddTask = () => {
  const { data: teamMembers, isLoading: teamLoading } = useGetTeamQuery();
  const { data: projects, isLoading: projectsLoading } = useGetProjectsQuery();
  const [addTask, { isSuccess }] = useAddTaskMutation();
  const navigate = useNavigate();

  const [taskName, setTaskName] = useState();
  const [teamMember, setTeamMember] = useState();
  const [project, setProject] = useState();
  const [deadline, setDeadline] = useState();

  useEffect(() => {
    if (isSuccess) {
      navigate("/");
    }
  }, [isSuccess, navigate]);

  const updatedTeamMember = teamMembers?.find(
    (member) => member.name === teamMember
  );
  const updatedProject = projects?.find(
    (allProject) => allProject.projectName === project
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      taskName,
      teamMember: updatedTeamMember,
      project: updatedProject,
      deadline,
      status: "Pending",
    };
    addTask(data);
  };

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
        Create Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                onChange={(e) => setTaskName(e.target.value)}
                value={taskName}
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                onChange={(e) => setTeamMember(e.target.value)}
                name="teamMember"
                id="lws-teamMember"
                required
              >
                <option value="" hidden>
                  Select Job
                </option>
                {teamLoading ? (
                  <option>Loading...</option>
                ) : (
                  teamMembers.map((member) => <option key={member.id}>{member.name}</option>)
                )}
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select
                onChange={(e) => setProject(e.target.value)}
                id="lws-projectName"
                name="projectName"
                required
              >
                <option value="" hidden>
                  Select Project
                </option>
                {projectsLoading ? (
                  <option>Loading...</option>
                ) : (
                  projects.map((project) => (
                    <option key={project.id}>{project.projectName}</option>
                  ))
                )}
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                onChange={(e) => setDeadline(e.target.value)}
                value={deadline}
                type="date"
                name="deadline"
                id="lws-deadline"
                required
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddTask;
